import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectWatermarkTemplates } from '../../fragments/generated/watermark_templates';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetProjectWatermarkTemplatesQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetProjectWatermarkTemplatesQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, watermarkTemplates?: { __typename?: 'WatermarkTemplateConnection', totalCount: number, nodes: Array<{ __typename?: 'WatermarkTemplate', id: string, deletedAt?: string | null, inUse: boolean, name: string, blocks?: Array<{ __typename?: 'WatermarkBlock', alpha?: number | null, fontSize?: Types.WatermarkFontSize | null, name?: string | null, position?: Types.WatermarkPosition | null, positionReferencePoint?: Types.WatermarkPosition | null, positionX?: number | null, positionY?: number | null, rotation?: number | null, scrollText?: Types.WatermarkScrollText | null, textAlignment?: Types.WatermarkTextAlignment | null, textColor?: string | null, textShadow?: boolean | null, dataPoints?: Array<{ __typename?: 'WatermarkDataPointCustomText', value?: string | null } | { __typename: 'WatermarkDataPointEmail' } | { __typename: 'WatermarkDataPointIpAddress' } | { __typename: 'WatermarkDataPointTimestamp' } | { __typename: 'WatermarkDataPointUserInput' } | { __typename: 'WatermarkDataPointUserName' } | null> | null } | null> | null }> } | null } | null } | null };


export const GetProjectWatermarkTemplates = /*#__PURE__*/ gql`
    query GetProjectWatermarkTemplates($projectId: ID!) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      id
      ...ProjectWatermarkTemplates
    }
  }
}
    ${ProjectWatermarkTemplates}` as unknown as DocumentNode<GetProjectWatermarkTemplatesQuery, GetProjectWatermarkTemplatesQueryVariables>;

          

          export const useGetProjectWatermarkTemplatesQuery = (options?:QueryHookOptions<GetProjectWatermarkTemplatesQuery, GetProjectWatermarkTemplatesQueryVariables>) => useQuery(GetProjectWatermarkTemplates, options);

          

          export type GetProjectWatermarkTemplatesQueryOptions = QueryHookOptions<GetProjectWatermarkTemplatesQuery, GetProjectWatermarkTemplatesQueryVariables>;

          

          export const useGetProjectWatermarkTemplatesLazyQuery = (options?:LazyQueryHookOptions<GetProjectWatermarkTemplatesQuery, GetProjectWatermarkTemplatesQueryVariables>) => useLazyQuery(GetProjectWatermarkTemplates, options);

          

          export type GetProjectWatermarkTemplatesQueryResult = ReturnType<typeof useGetProjectWatermarkTemplatesQuery>;

          
